// A detail page's header pieces, one look across the office (29 Oct 2026, header review: the spec page
// ran its status as a mono caps sentence, its terms as one dotted line and its notes as a wall of text).
//   Facts / Fact  - label above value, wrapping in a row (the receipt page's header, shared).
//   Clamped       - long prose held to two lines with Show all / Show less; the words stay in the DOM.
import { useState, type ReactNode } from 'react';

export function Facts({ children, className = '' }: { children: ReactNode; className?: string }) {
  return <dl className={`m-0 mt-(--s3) flex flex-wrap gap-x-(--s5) gap-y-(--s2) ${className}`}>{children}</dl>;
}

export function Fact({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div className="flex min-w-0 flex-col">
      <dt className="text-[11px] font-semibold uppercase tracking-[0.06em] text-(--muted)">{label}</dt>
      <dd className="m-0 text-(length:--fs-sm) [overflow-wrap:anywhere]">{children}</dd>
    </div>
  );
}

export function Clamped({ text, label = 'Notes' }: { text: string; label?: string }) {
  const [open, setOpen] = useState(false);
  const long = text.length > 180;
  return (
    <div className="mt-(--s3) max-w-[80ch]">
      <p className="m-0 text-[11px] font-semibold uppercase tracking-[0.06em] text-(--muted)">{label}</p>
      <p className={`m-0 text-(length:--fs-sm) text-(--muted) ${long && !open ? 'line-clamp-2' : ''}`}>{text}</p>
      {long ? (
        <button
          type="button"
          className="mt-(--s1) text-(length:--fs-xs) font-semibold text-(--primary) underline-offset-2 hover:underline"
          aria-expanded={open}
          onClick={() => setOpen((o) => !o)}
        >
          {open ? 'Show less' : 'Show all'}
        </button>
      ) : null}
    </div>
  );
}
